// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {isRequestSubmitted} from '../services/labor-rate-change-services';

const SubmitButton = props =>
    <section className='submit-request'>
        {isRequestSubmitted(props.laborRate) ?
            <FormattedMessage id='REQUEST_SUBMITTED'/> :
            <button
                className='button-primary'
                disabled={props.isSubmitDisabled}
                onClick={props.onClick}
            >
                <FormattedMessage id='SUBMIT_REQUEST'/>
            </button>
        }
    </section>;

SubmitButton.displayName = 'SubmitButton';
SubmitButton.propTypes = {
    isSubmitDisabled: PropTypes.bool.isRequired,
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    onClick: PropTypes.func.isRequired
};
export default SubmitButton;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/components/submit-button.js